// debug.js
export const Debug = {
    dotNetRef: null,
    _swListenerAttached: false,

    attachDotNet(dotNetRef) {
        this.dotNetRef = dotNetRef;

        if (!('serviceWorker' in navigator)) return;
        if (this._swListenerAttached) return;

        navigator.serviceWorker.addEventListener('message', event => {
            if (event.data?.source === 'sw' && this.dotNetRef) {
                this.dotNetRef.invokeMethodAsync(
                    'ReceiveSWLog',
                    event.data
                );
            }
        });

        this._swListenerAttached = true;
    },

    log(msg) {
        const el = document.getElementById("fs-debug-log");
        if (!el) return;
        const line = document.createElement("div");
        line.textContent = `[${new Date().toLocaleTimeString()}] ${msg}`;
        el.prepend(line);
    },

    async getSWStatus() {
        const reg = await navigator.serviceWorker.getRegistration();
        return reg ? 'active' : 'not registered';
    },

    async getCacheStatus() {
        const keys = await caches.keys();
        return keys.length ? `${keys.length} cache(s)` : 'empty';
    },

    async clearCache() {
        const keys = await caches.keys();
        await Promise.all(keys.map(k => caches.delete(k)));
    }
};
